'use strict';

$(document).ready(function () {
    var $videoComponents = $('.video-component');
    if ($videoComponents.length) {
        var ratio = window.app.isDesktop() ? 2.2 : 1.6;
        $videoComponents.each(function () {
            $(this).css('height', ($(this).width() || $(this).offsetWidth) / ratio);
        });
    }
});
